import { createSelector } from 'reselect';
import { Company } from 'data/v1/data-contracts';

export const selectCompanyId = createSelector(
  (state: { company: Company }) => state.company,
  (company) => company.id,
);
